import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import FormControl from '@mui/material/FormControl';
// @mui/icons-material
// core components
import styles from '@/assets/jss/material-dashboard-react/components/customInputStyle';
import { TextField } from '@mui/material';

const useStyles = makeStyles(styles);

export default function CustomInput(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    onChange,
    onKeyPress,
    value,
    placeholder,
    onKeyUp,
    inputProps,
    type,
    error,
    success,
    name,
    disabled = false,
    dataTestId,
    helperTextStyle,
    maxLength,
  } = props;

  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
  });
  const marginTop = classNames({
    [classes.marginTop]: labelText === undefined,
  });
  return (
    <div className='custom-select'>
      <FormControl
        {...formControlProps}
        className={
          (formControlProps?.className ?? '') + ' ' + classes.formControl
        }>
        <TextField
          classes={{
            root: marginTop,
            disabled: classes.disabled,
            underline: underlineClasses,
          }}
          id={id}
          error={error}
          label={labelText}
          type={type}
          onChange={onChange}
          value={value}
          name={name}
          onKeyUp={onKeyUp}
          onKeyPress={onKeyPress}
          placeholder={placeholder}
          disabled={disabled}
          variant='standard'
          data-testid={dataTestId}
          inputProps={{
            maxLength: maxLength,
          }}
          FormHelperTextProps={{
            style: helperTextStyle,
            ...(inputProps?.FormHelperTextProps || {}),
          }}
          {...inputProps}
        />
      </FormControl>
    </div>
  );
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  onKeyUp: PropTypes.string,
  onKeyPress: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool,
  helperTextStyle: PropTypes.object,
  maxLength: PropTypes.number,
};
